import { alpha, Theme } from "@mui/material/styles";
import { ButtonProps } from "@mui/material/Button";

export function getActionButtonStyles(
  theme: Theme,
  color: ButtonProps["color"] = "inherit",
) {
  const isNeutral = color === "inherit";
  // Change the neutral foreground here to recolor every contextual action.
  const foreground = isNeutral
    ? theme.palette.text.primary
    : color === "warning"
    ? theme.palette.warning.dark
    : color === "success"
    ? theme.palette.success.dark
    : theme.palette[color].main;

  return {
    color: foreground,
    border: `1px solid ${
      isNeutral ? theme.palette.divider : alpha(foreground, 0.4)
    }`,
    backgroundColor: "transparent",
    fontWeight: 500,
    lineHeight: 1.5,
    whiteSpace: "nowrap" as const,
    textAlign: "left" as const,
    "&:hover, &.Mui-focusVisible": {
      color: foreground,
      borderColor: isNeutral
        ? theme.palette.text.secondary
        : alpha(foreground, 0.7),
      backgroundColor: isNeutral
        ? theme.palette.action.hover
        : alpha(foreground, 0.06),
    },
    "&.Mui-disabled": {
      color: theme.palette.action.disabled,
      borderColor: theme.palette.action.disabledBackground,
      backgroundColor: "transparent",
    },
    "&.Mui-disabled[aria-busy=true]": {
      color: foreground,
    },
  };
}
